import {UserFilter} from "./models/UserFilter";
import UserFilterEvents from "./UserFilterEvents";

export const resetUserfilter = (UserFilters: UserFilter) => ({
    type: UserFilterEvents.resetUserfilter,
    UserFilters
} as const);
